import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { createVisitor } from '~libs.typescript';

const POLAND_COUNTRY_PREFIX = '48';
const SMS_CAPABLE_COUNTRY_PREFIXES = [POLAND_COUNTRY_PREFIX];

export const phoneNumberSmsCapabilitiesVisitor = createVisitor<
   PhoneNumber | null | undefined,
   {
      visitNotProvided: void;
      visitSmsCapable: void;
      visitSmsIncapable: void;
   }
>((phoneNumber, visitor) => {
   if (!phoneNumber) {
      return visitor.visitNotProvided?.();
   }

   if (SMS_CAPABLE_COUNTRY_PREFIXES.includes(phoneNumber.getCountryPrefix())) {
      return visitor.visitSmsCapable?.();
   }

   return visitor.visitSmsIncapable?.();
});
